export const systemConstants = {
  SERVICE_URL: '/'
  //SERVICE_URL: 'http://localhost:3000/'
};






// WEBPACK FOOTER //
// ./src/constants/index.js